var _circle, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearDustMask50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.666,25.187L36,21.77V20.5C36,13.607,30.393,8,23.5,8S11,13.607,11,20.5 c0,5.19,1.469,8.097,2.649,10.432C14.404,32.425,15,33.604,15,35v4h2v-4c0-1.873-0.761-3.378-1.565-4.971 C14.293,27.772,13,25.214,13,20.5C13,14.71,17.71,10,23.5,10S34,14.71,34,20.5v1.73l2.017,4.136L34,27.32V32c0,1.654-1.346,3-3,3h-4 v4h2v-2h2c2.757,0,5-2.243,5-5v-3.414l0.791-0.374c0.495-0.232,0.876-0.644,1.069-1.152C38.1,26.438,38.026,25.744,37.666,25.187z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12.931,
    x: 20.812,
    y: 27.911,
    fill: "#fff",
    transform: "rotate(-73.14 21.812 34.377)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.161,24.161C35.168,24.858,32.811,26,28,26c-0.358,0-0.686-0.019-1-0.044V37h4 c3.866,0,7-3.134,7-7v-3.76L36.161,24.161z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28,27c-2.168,0-3.563-0.548-3.621-0.571l-12.294-3.722l0.58-1.914l12.375,3.75 C25.128,24.574,26.244,25,28,25c5.579,0,7.247-1.659,7.263-1.676l0.083-0.086l1.329,1.503C36.213,25.204,34.03,27,28,27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearDustMask50);
export default __webpack_public_path__ + "static/media/icons8-wear-dust-mask-50.5402d8a697c4558a33ee0673509b075b.svg";
export { ForwardRef as ReactComponent };